// ============================================================================= //
//  JS detection
// ============================================================================= //
document.body.classList.remove("no-js");

// ============================================================================= //
//  Modules
// ============================================================================= //
import "./modules/accordion";
import "./modules/mobile-navigation";
import "./modules/site-header";
// import "./modules/counters";
import "./modules/smooth-scroll";
// import "./modules/video-load";
import "./modules/swiper";
// import "./modules/panels";
import "./modules/animation";
// import "./modules/animated-lines";
// // import "./modules/animated-accordion";
// import "./modules/animated-button";
//  import "./modules/vertical-scroll";
// import "./modules/horizontal";
// import "./modules/popup";
// import "./modules/form";
// // import "./modules/scroll-up";
// import "./modules/photoswipe";
// import "./modules/progress";
// import 'magniview/dist/magniview-min.js';



